export default __webpack_public_path__ + "static/media/kit_svg5.394ac206.svg";